module.exports = __webpack_public_path__ + "fonts/nunito-sans-latin-ext.f54029f.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nunito-sans/nunito-sans-latin-ext.woff2
// module id = 582
// module chunks = 0